import { FastField, Field, Formik } from 'formik';
import KTFormGroup from 'general/components/OtherKeenComponents/Forms/KTFormGroup';
import KTFormInput, {
  KTFormInputType,
} from 'general/components/OtherKeenComponents/Forms/KTFormInput';
import KTBSButton, {
  KTBSButtonColor,
  KTBSButtonSize,
} from 'general/components/OtherKeenComponents/KTBSButton';
import InputSearchDropdown from 'general/components/Others/InputSearchDropdown';
import AppColors from 'general/constants/AppColors';
import Utils from 'general/utils/Utils';
import _ from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';

ViewAddEnergyBill.propTypes = {
  onClosed: PropTypes.func,
  onSubmitted: PropTypes.func,
  stationList: PropTypes.array,
};

function ViewAddEnergyBill(props) {
  // MARK: ---- params ----
  const { onClosed, onSubmitted, stationList } = props;
  const { t } = useTranslation();
  const [qCS, setQCS] = useState('');
  const stationOptions = useMemo(() => {
    return stationList
      ?.filter((row) => row?.name?.includes(qCS) || row?.stationCode?.includes(qCS))
      ?.map((row) => {
        return {
          title: row?.name,
          subTitle: row?.stationCode,
          value: row?.stationId,
        };
      });
  }, [stationList, qCS]);

  return (
    <div>
      <Formik
        initialValues={{
          stationId: '',
          // test
          // amount: 2000000,
          // month: moment().format('YYYY-MM'),
          // evnCustomerId: '123456',
          // evnCustomerName: 'Nguyen Van A',
          // evnEnergyUsed: 1000,
          // evnBeginingCycleCounter: 500,
          // evnEndingCycleCounter: 1500,
          // evnInvoiceSerial: '123456ABCDEF',
          // evnInvoiceNo: '123456',

          amount: 0,
          month: moment().format('YYYY-MM'),
          evnCustomerId: '',
          evnCustomerName: '',
          evnEnergyUsed: 0,
          evnBeginingCycleCounter: 0,
          evnEndingCycleCounter: 0,
          evnInvoiceSerial: '',
          evnInvoiceNo: '',
        }}
        enableReinitialize={true}
        validationSchema={Yup.object({
          stationId: Yup.string().required('Bắt buộc'),
          amount: Yup.number().required('Bắt buộc').min(0, 'Số tiền không hợp lệ'),
          month: Yup.string().required('Bắt buộc'),
          evnCustomerId: Yup.string().required('Bắt buộc')
            .test('len', t('invalid', { field: 'evnCustomerId' }), (val) => {
              if (val) {
                return val.toString().trim();
              }
            }),
          evnCustomerName: Yup.string().required('Bắt buộc')
            .test('len', t('invalid', { field: 'evnCustomerName' }), (val) => {
              if (val) {
                return val.toString().trim();
              }
            }),
          evnEnergyUsed: Yup.number().required('Bắt buộc').min(0, 'Số không hợp lệ'),
          evnBeginingCycleCounter: Yup.number().required('Bắt buộc').min(0, 'Số không hợp lệ'),
          evnEndingCycleCounter: Yup.number().required('Bắt buộc').min(0, 'Số không hợp lệ'),
          evnInvoiceSerial: Yup.string().required('Bắt buộc')
            .test('len', t('invalid', { field: 'evnInvoiceSerial' }), (val) => {
              if (val) {
                return val.toString().trim();
              }
            }),
        })}
        onSubmit={(values) => {
          if (onSubmitted) {
            onSubmitted(values);
          }
        }}
      >
        {(formikProps) => (
          <div className="rounded-bottom-lg" style={{ backgroundColor: AppColors.gray[100] }}>
            {/* thong tin hoa don */}
            <div className="p-4">
              <div className="row">
                {/* tram sac */}
                <div className="col-12">
                  <KTFormGroup
                    label={<span className="font-weight-boldest"
                      style={{
                        color: AppColors.gray[800]
                      }}
                    >{t('Trạm sạc')} </span>}
                    inputName="stationId"
                    isRequired={true}
                    inputElement={
                      <Field name="stationId">
                        {({ field, form, meta }) => {
                          return (
                            <InputSearchDropdown
                              inputName={field.name}
                              selectedValue={field.value}
                              onSelectedValueChanged={(value) => {
                                form.setFieldValue(field.name, value);
                                setQCS('');
                              }}
                              items={stationOptions}
                              onSubmitSearch={(text) => {
                                setQCS(text);
                              }}
                              selectedText={
                                _.find(
                                  stationList,
                                  (row) => row?.stationId == formikProps?.values?.stationId
                                )?.name
                              }
                              enableCheckValid={true}
                              isTouched={meta.touched}
                              isValid={_.isEmpty(meta.error)}
                              feedbackText={meta.error}
                              onBlur={() => {
                                form.setFieldTouched(field.name, true);
                              }}
                            />
                          );
                        }}
                      </Field>
                    }
                  />
                </div>
                <div className='col-12'>
                  <div className='mb-4' style={{
                    borderBottom: `1px dashed ${AppColors.gray[300]}`
                  }} />
                </div>
                <span
                  style={{
                    fontWeight: '600',
                    fontSize: Utils.returnFontSize(18),
                    color: AppColors.gray[900],
                  }}
                >
                  Thông tin hoá đơn
                </span>
                {/* ma khach hang evn */}
                <div className="col-lg-6 mt-3">
                  <KTFormGroup
                    label={<span className="font-weight-bolder">{t('Mã khách hàng tại EVN')} </span>}
                    inputName="evnCustomerId"
                    isRequired={true}
                    inputElement={
                      <FastField name="evnCustomerId">
                        {({ field, form, meta }) => {
                          return (
                            <KTFormInput
                              name={field.name}
                              value={field.value}
                              onChange={(value) => {
                                form.setFieldValue(field.name, value);
                              }}
                              onBlur={() => {
                                form.setFieldTouched(field.name, true);
                              }}
                              enableCheckValid={true}
                              type={KTFormInputType.text}
                              placeholder={t('Nhập mã')}
                              isValid={_.isEmpty(meta.error)}
                              isTouched={meta.touched}
                              feedbackText={meta.error}
                            />
                          );
                        }}
                      </FastField>
                    }
                  />
                </div>
                {/* ten khach hang evn */}
                <div className="col-lg-6 mt-3 pl-lg-0">
                  <KTFormGroup
                    label={<span className="font-weight-bolder">{t('Tên khách hàng')} </span>}
                    inputName="evnCustomerName"
                    isRequired={true}
                    inputElement={
                      <FastField name="evnCustomerName">
                        {({ field, form, meta }) => {
                          return (
                            <KTFormInput
                              name={field.name}
                              value={field.value}
                              onChange={(value) => {
                                form.setFieldValue(field.name, value);
                              }}
                              onBlur={() => {
                                form.setFieldTouched(field.name, true);
                              }}
                              enableCheckValid={true}
                              type={KTFormInputType.text}
                              placeholder={t('Nhập tên')}
                              isValid={_.isEmpty(meta.error)}
                              isTouched={meta.touched}
                              feedbackText={meta.error}
                            />
                          );
                        }}
                      </FastField>
                    }
                  />
                </div>
                {/* thang */}
                <div className="col-lg-6">
                  <KTFormGroup
                    label={<span className="font-weight-bolder">{t('Tháng')} </span>}
                    inputName="month"
                    isRequired={true}
                    inputElement={
                      <FastField name="month">
                        {({ field, form, meta }) => {
                          return (
                            <KTFormInput
                              name={field.name}
                              value={field.value}
                              onChange={(value) => {
                                form.setFieldValue(field.name, value);
                              }}
                              onBlur={() => {
                                form.setFieldTouched(field.name, true);
                              }}
                              enableCheckValid={false}
                              type={KTFormInputType.month}
                              placeholder={t('Nhập tháng')}
                              isValid={_.isEmpty(meta.error)}
                              isTouched={meta.touched}
                              feedbackText={meta.error}
                            />
                          );
                        }}
                      </FastField>
                    }
                  />
                </div>
                {/* serial hoa don evn */}
                <div className="col-lg-6 pl-lg-0">
                  <KTFormGroup
                    label={
                      <span className="font-weight-bolder">{t('Số serial biên lai')} </span>
                    }
                    inputName="evnInvoiceSerial"
                    isRequired={true}
                    inputElement={
                      <FastField name="evnInvoiceSerial">
                        {({ field, form, meta }) => {
                          return (
                            <KTFormInput
                              name={field.name}
                              value={field.value}
                              onChange={(value) => {
                                form.setFieldValue(field.name, value);
                              }}
                              onBlur={() => {
                                form.setFieldTouched(field.name, true);
                              }}
                              enableCheckValid={true}
                              type={KTFormInputType.text}
                              placeholder={t('Nhập số serial biên lai')}
                              isValid={_.isEmpty(meta.error)}
                              isTouched={meta.touched}
                              feedbackText={meta.error}
                            />
                          );
                        }}
                      </FastField>
                    }
                  />
                </div>
                {/* so dien da su dung */}
                <div className="col-lg-6">
                  <KTFormGroup
                    label={<span className="font-weight-bolder">{t('Số điện đã dùng')} </span>}
                    inputName="evnEnergyUsed"
                    isRequired={true}
                    inputElement={
                      <FastField name="evnEnergyUsed">
                        {({ field, form, meta }) => {
                          return (
                            <KTFormInput
                              name={field.name}
                              value={field.value}
                              onChange={(value) => {
                                form.setFieldValue(field.name, value);
                              }}
                              onBlur={() => {
                                form.setFieldTouched(field.name, true);
                              }}
                              enableCheckValid={true}
                              type={KTFormInputType.number}
                              placeholder={t('Nhập số')}
                              isValid={_.isEmpty(meta.error)}
                              isTouched={meta.touched}
                              feedbackText={meta.error}
                              unit="kWh"
                            />
                          );
                        }}
                      </FastField>
                    }
                  />
                </div>
                {/* chi so bat dau */}
                <div className="col-lg-6 pl-lg-0">
                  <KTFormGroup
                    label={<span className="font-weight-bolder">{t('Số điện đầu tháng')} </span>}
                    inputName="evnBeginingCycleCounter"
                    isRequired={true}
                    inputElement={
                      <FastField name="evnBeginingCycleCounter">
                        {({ field, form, meta }) => {
                          return (
                            <KTFormInput
                              name={field.name}
                              value={field.value}
                              onChange={(value) => {
                                form.setFieldValue(field.name, value);
                              }}
                              onBlur={() => {
                                form.setFieldTouched(field.name, true);
                              }}
                              enableCheckValid={true}
                              type={KTFormInputType.number}
                              placeholder={t('Nhập số')}
                              isValid={_.isEmpty(meta.error)}
                              isTouched={meta.touched}
                              feedbackText={meta.error}
                              unit="kWh"
                            />
                          );
                        }}
                      </FastField>
                    }
                  />
                </div>
              </div>
            </div>
            {/* actions */}
            <div className="d-flex align-items-center gap-3 justify-content-end bg-white p-4 border-top rounded-bottom-lg">
              <KTBSButton
                color={KTBSButtonColor.secondary}
                title={t('cancel')}
                size={KTBSButtonSize.large}
                borderRadius={5}
                buttonTitleFontWeight="600"
                onPress={onClosed}
                buttonTitleColor={'rgba(74, 86, 119, 1)'}
              // additionalClassName="w-100"
              />
              <KTBSButton
                color={KTBSButtonColor.success}
                title={t('Thêm')}
                size={KTBSButtonSize.large}
                borderRadius={5}
                buttonTitleFontWeight="600"
                onPress={async () => {
                  const errors = await formikProps.validateForm();
                  console.log('errors: ', errors);
                  formikProps.handleSubmit();
                }}
              // additionalClassName="w-100"
              />
            </div>
          </div>
        )}
      </Formik>
    </div>
  );
}

export default ViewAddEnergyBill;
